import React from "react";
import "./AFSignIn.scss";
import { useTranslation } from "react-i18next";
import Input from "../../../Form/Inputs/Input";
import AFButton from "../AFButton/AFButton";
import ErrorText from "../../../Form/ErrorText/ErrorText";
const AFSignIn = ({
  ButtonText,
  inputPlaceholder,
  loading,
  error,
  handleSubmit,
  email,
  setEmail,
}) => {
  const { t } = useTranslation();
  return (
    <div id='AFSignIn'>
      <div className='AFsignbox'>
        <div className='text'>
          {t(
            "landing.accessLoadboard.After entering your email, you will receive an access link in your inbox. Use it to access the load board."
          )}
        </div>
        <div className='AFformBox'>
          <Input
            id={"InputAF"}
            type='email'
            placeholder={t("landing.accessLoadboard.Enter email")}
            value={email}
            setValue={setEmail}
            error={error?.errors?.email?.[0]}
          />
          <ErrorText error={error?.errors?.email?.[0]} />
          <AFButton
            loading={loading}
            submitHandler={handleSubmit}
            text={ButtonText ? ButtonText : t("landing.accessLoadboard.Send link to an email")}
          />
        </div>
      </div>
    </div>
  );
};

export default AFSignIn;
